module.exports = __webpack_public_path__ + "img/click.5f2c3529.svg";